/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Helmet } from 'react-helmet';
import SplashScreen from 'blocks/SplashScreen/index';
import Navigation from 'blocks/Navigation';
import NavigationAwarePageContent from 'blocks/NavigationAwarePageContent';
import styled from 'styled-components';
import ds, { media } from 'designsystem';

const PageNotFoundContainer = styled.div`
  position: relative;
  top: ${ds.get('metrics.s')};
  min-height: 520px;

  display: flex;
  align-items: center;
  justify-content: center;

  padding: ${ds.get('metrics.s')};
  flex-direction: column;
      
  ${media.tablet`
    position: relative;
    top: ${ds.get('metrics.xxl')};
    min-height: 400px;
    height: 40vh;
    flex-direction: row;
  `}
`;

const ErrorCode = styled.p`
  font-family: ${ds.get('type.fontFamily.headline')};
  font-size: ${ds.fs('xxl')};
  
  ${media.tablet`
    font-size: ${ds.fs('xl')};
    padding-right: ${ds.get('metrics.s')};
  `}
`;

const PageNotFoundText = styled.p`
  font-family: ${ds.get('type.fontFamily.text')};
  font-size: ${ds.fs('m')};
  line-height: ${ds.get('type.lineHeight.s')};
  margin-top: -${ds.get('metrics.m')};
  text-align: center;
  
  ${media.tablet`
    margin-top: ${ds.get('metrics.m')};
  `};
`;


@inject('coreStore')
@observer
class PageNotFound extends Component {
  render() {
    const {
      coreStore: {
        isLoaded,
        translations,
      },
    } = this.props;

    if (!isLoaded) {
      return <SplashScreen />;
    }

    return (
      <React.Fragment>
        <Helmet>
          <meta name="prerender-status-code" content="404" />
        </Helmet>
        <Navigation />
        <NavigationAwarePageContent>
          <PageNotFoundContainer>
            <ErrorCode> 404 </ErrorCode>
            <PageNotFoundText>
              {translations.PAGE_NOT_FOUND_TEXT}
            </PageNotFoundText>
          </PageNotFoundContainer>
        </NavigationAwarePageContent>
      </React.Fragment>
    );
  }
}
export default PageNotFound;



// WEBPACK FOOTER //
// ./src/pages/PageNotFound/index.jsx